/**
 * Gives authenticated users a clear support path when they have no active access assignment.
 * Content is split out because routes rendered inside Root already have the application shell.
 */
import React from 'react';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Link from '@amzn/meridian/link';
import Text from '@amzn/meridian/text';
import { useTranslation } from 'src/arb-wrapper';
import { BasicLayout } from 'src/components/common/BasicLayout';
import { NO_ACCESS_SUPPORT_EMAIL } from 'src/constants';

export const NoAccessContent: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Column
      alignmentHorizontal="center"
      alignmentVertical="center"
      spacingInset="500 600"
    >
      <Heading data-testid="no-access-heading" level={1}>
        {t('no_access_page_heading')}
      </Heading>
      <Text data-testid="no-access-body">{t('no_access_page_body')}</Text>
      <Link data-testid="no-access-support-link" href={`mailto:${NO_ACCESS_SUPPORT_EMAIL}`}>
        {NO_ACCESS_SUPPORT_EMAIL}
      </Link>
    </Column>
  );
};

export const NoAccessPage: React.FC = () => (
  <BasicLayout>
    <NoAccessContent />
  </BasicLayout>
);
